module.exports = __webpack_public_path__ + "ye.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ye.svg
// module id = 1147
// module chunks = 0